import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Fade } from 'react-awesome-reveal'
class Footer extends Component {
  render() {
    let lanaData = this.props.lanaData
    return (
      <section className="footer-area">
        <div className="container">
          <div className="footer-content">
            <Link to="/" className="logo wow fadeInDown" data-wow-delay="0.4s">
              {/* <img src={require('../image/logo2.png')} alt="" /> */}
              <img
                style={{
                  border: '1px solid black',
                  borderRadius: '50%',
                  width: '50%',
                }}
                src={require('../image/Logo_lana/Logo_lana_modifie.jpg')}
                alt=""
              />
            </Link>
            <Fade direction="down" cascade triggerOnce>
              <ul className="list_style">
                {lanaData.socialLinks.map((item) => {
                  return (
                    <li key={item.name}>
                      <a href={item.url}>
                        <i className={item.className}></i>
                      </a>
                    </li>
                  )
                })}
              </ul>
            </Fade>

            <h6>
              Made with love by <a href="#">LanaDiaspora</a>
            </h6>
            <p>© 2023 LanaDiaspora - All Rights Reserved</p>
          </div>
        </div>
      </section>
    )
  }
}
export default Footer
